import viCommon from './vi/common';
import viHome from './vi/home';
import viLatvia from './vi/latvia';
import viChoHem from './vi/choHem';
import viPartnership from './vi/partnership';
import viAbout from './vi/about';
import viContact from './vi/contact';
import viBlog from './vi/blog';

import enCommon from './en/common';
import enHome from './en/home';
import enLatvia from './en/latvia';
import enChoHem from './en/choHem';
import enPartnership from './en/partnership';
import enAbout from './en/about';
import enContact from './en/contact';
import enBlog from './en/blog';

import lvCommon from './lv/common';
import lvHome from './lv/home';
import lvLatvia from './lv/latvia';
import lvChoHem from './lv/choHem';
import lvPartnership from './lv/partnership';
import lvAbout from './lv/about';
import lvContact from './lv/contact';
import lvBlog from './lv/blog';

const resources = {
  vi: {
    common: viCommon,
    home: viHome,
    latvia: viLatvia,
    choHem: viChoHem,
    partnership: viPartnership,
    about: viAbout,
    contact: viContact,
    blog: viBlog,
  },
  en: {
    common: enCommon,
    home: enHome,
    latvia: enLatvia,
    choHem: enChoHem,
    partnership: enPartnership,
    about: enAbout,
    contact: enContact,
    blog: enBlog,
  },
  lv: {
    common: lvCommon,
    home: lvHome,
    latvia: lvLatvia,
    choHem: lvChoHem,
    partnership: lvPartnership,
    about: lvAbout,
    contact: lvContact,
    blog: lvBlog,
  },
};

export default resources;